<script setup>
import { Head } from '@inertiajs/vue3'
import { useI18n } from 'vue-i18n'
import PartnersLayout from '@/Layouts/PartnersLayout.vue'

defineOptions({ layout: PartnersLayout })
const { t } = useI18n()
defineProps({
  status: { type: String, default: 'invalid' },
  portal_url: { type: String, default: '' },
  email: { type: String, default: '' }
})
</script>

<template>
  <Head>
    <title>{{ t('partners.verified.head_title') }}</title>
  </Head>

  <template v-if="status === 'verified'">
    <h1 class="v-title">
      {{ t('partners.verified.title') }}
    </h1>
    <p class="v-body">
      {{ t('partners.verified.body') }}
    </p>
    <a
      :href="portal_url"
      class="v-cta"
    >{{ t('partners.verified.cta') }}</a>
  </template>

  <template v-else-if="status === 'expired'">
    <h1 class="v-title">
      {{ t('partners.verified.expired_title') }}
    </h1>
    <p class="v-body">
      {{ t('partners.verified.expired_body') }}
    </p>
  </template>

  <template v-else>
    <h1 class="v-title">
      {{ t('partners.verified.invalid_title') }}
    </h1>
    <p class="v-body">
      {{ t('partners.verified.invalid_body') }}
    </p>
  </template>
</template>

<style scoped>
.v-title { font-size: 1.25rem; font-weight: 700; color: var(--ink); margin: 0 0 0.5rem; }
.v-body { color: var(--inkSoft); font-size: 0.9375rem; line-height: 1.5; margin: 0 0 1rem; }
.v-cta { display: inline-block; padding: 0.65rem 1.1rem; border-radius: var(--radius-button, 8px); background: var(--accent); color: var(--accentInk); font-weight: 600; text-decoration: none; }
</style>
